import apiV2 from "api-v2";
import type {
	EvaluationState,
	StartEvaluationPayload,
	UpdateEvaluationStepPayload,
} from "../types/evaluation.type";

// TODO: Replace stub endpoints with real API paths when backend is available

export const getEvaluationState = async (
	rfxId: number,
	rfxSubmissionId?: number
): Promise<EvaluationState | null> => {
	const params = rfxSubmissionId ? { rfxSubmissionId } : {};
	const response = await apiV2.get<EvaluationState>(
		`/rfx/${rfxId}/evaluation`,
		{ params }
	);
	return response.data ?? null;
};

export const startEvaluation = async (
	payload: StartEvaluationPayload
): Promise<EvaluationState> => {
	const response = await apiV2.post<EvaluationState>(
		`/rfx/${payload.rfxId}/evaluation/start`,
		payload
	);
	return response.data;
};

export const updateEvaluationStep = async (
	payload: UpdateEvaluationStepPayload
): Promise<EvaluationState> => {
	const response = await apiV2.patch<EvaluationState>(
		`/rfx/${payload.rfxId}/evaluation/step/${payload.stepId}`,
		payload
	);
	return response.data;
};
